import { Table, Text } from '@quintoandar-tokko/jopijs';
import { parseISO, format } from 'date-fns';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import VisitCell from '../components/VisitCell';
import VisitQualificationCell from '../components/VisitQualificationCell';
import EllipsisWithTooltip from '@/components/shared/EllipsisWithTooltip/EllipsisWithTooltip';

export default function DoneVisitsTableRow({
  doneVisit,
  showQualificationColumn = false,
}) {
  const {
    id,
    properties,
    visit_type,
    contacts,
    agents,
    when,
    qualification,
    closing_reason,
  } = doneVisit;
  const arbitraryProperty = properties.find((el) => el.id);
  const agentNames = (agents ?? [])
    .map((agent) => agent?.name)
    .filter(Boolean)
    .join(', ');

  const contactNames = (contacts ?? [])
    .map((contact) => contact?.name)
    .filter(Boolean)
    .join(', ');

  const date = parseISO(when);
  const dateFormatted = format(date, 'dd/MM/yyyy');

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={arbitraryProperty?.id}
          thumbnail={arbitraryProperty?.thumbnail}
          address={arbitraryProperty?.address}
          location={arbitraryProperty?.location}
          modal="doneVisits"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <VisitCell id={id} name={visit_type?.name} />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <div className={styles.ellipsisCellContent}>
          <EllipsisWithTooltip
            text={contactNames}
            className={styles.ellipsisTooltipContainer}
          />
        </div>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <div className={styles.ellipsisCellContent}>
          <EllipsisWithTooltip
            text={agentNames}
            className={styles.ellipsisTooltipContainer}
          />
        </div>
      </Table.RowItemDefault>

      {showQualificationColumn && (
        <Table.RowItemDefault
          variant="secondary"
          className={styles.tableBodyCell}
        >
          <VisitQualificationCell
            qualification={qualification}
            label={closing_reason}
          />
        </Table.RowItemDefault>
      )}

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{dateFormatted}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
